import styled, { css } from 'styled-components';

export const TextStatusContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const TextStatus = styled.div<ILineText>`
  color: #c1c4d6;
  font-size: 14px;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
`;

export const LineContainer = styled.div`
  display: flex;
  align-items: center;
`;

interface ILineTextError {
  limitOfLines?: number;
}

export const LineTextError = styled.div<ILineTextError>`
  color: #d14343;
  font-size: 14px;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const Item = styled.div`
  margin: 0 40px;

  & + & {
    margin-top: 12px;
  }

  &[data-status='identified'],
  &[data-isfindmatched='approx_match'] {
    margin: 0;

    & + & {
      margin-top: 12px;
    }
  }
  position: relative;
`;

interface IHeader {
  isAccessory?: boolean;
}

export const Header = styled.div<IHeader>`
  background: ${({ isAccessory }) => (isAccessory ? '#FDF7F4' : '#f5f7fb')};
  border-radius: 8px;

  &[data-status='identified'],
  &[data-isfindmatched='approx_match'] {
    background: #fff;
  }

  &[data-isgroupopen='true'] {
    position: relative;
    border-radius: 8px 8px 0px 0px;
    ::after {
      content: '';
      height: 1px;
      width: 100%;
      background-color: #e6e8f0;
      position: absolute;
      left: 15px;
      right: 15px;
      bottom: 0;
      width: calc(100% - 30px);
    }
  }
`;

interface INoText {
  isError?: boolean;
}

export const NoText = styled.div<INoText>`
  color: ${({ isError }) => (isError ? '#D14343' : '#c1c4d6')};
  font-size: 14px;
  font-style: italic;
`;

interface ILineText {
  limitOfLines?: number;
}

export const LineText = styled.div<ILineText>`
  color: #474d66;
  font-size: 14px;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const Line = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 3fr 3fr 1fr 2fr;
  grid-gap: 16px;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;

  & + & {
    margin-top: 12px;
  }
`;

export const FirstColumn = styled.div`
  display: flex;
  align-items: center;
`;

export const RightIcon = styled.div`
  height: 20px;
  margin-right: 16px;
`;

export const Bottom = styled.div`
  padding: 12px 8px;
  height: 42px;
`;

export const ColumnsFieldsWrapper = styled.div`
  top: 0;
  position: sticky;
  z-index: 1;
`;

interface IColumnsFields {
  columns: number;
  isAccessory?: boolean;
  columnFieldBorder?: string;
}

export const ColumnsFields = styled.div<IColumnsFields>`
  display: grid;
  grid-template-columns: repeat(
    ${({ columns }) => columns},
    minmax(150px, 1fr)
  );
  grid-auto-flow: column;
  grid-gap: 16px;
  padding: 12px 16px;
  background: ${({ isAccessory }) => (isAccessory ? '#FDF7F4' : '#f5f7fb')};
  width: 100%;
  border-radius: 0px 0px 8px 8px;
  overflow: hidden;

  &[data-status='identified'],
  &[data-isfindmatched='approx_match'] {
    background: #fff;
  }
`;

export const ColumnField = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #1b203a;
  white-space: nowrap;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  scroll-snap-align: start;
`;

export const Assets = styled.div`
  overflow: auto;

  ::-webkit-scrollbar {
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
`;

interface IAssetRow {
  columns: number;
}

export const AssetRow = styled.div<IAssetRow>`
  display: grid;
  grid-template-columns: repeat(
    ${({ columns }) => columns},
    minmax(150px, 1fr)
  );
  grid-auto-flow: column;
  grid-gap: 16px;
  padding: 16px;
  position: relative;
  width: 100%;

  :not(:last-child)::after {
    content: '';
    height: 1px;
    width: 100%;
    background-color: #e6e8f0;
    position: absolute;
    left: 8px;
    right: 8px;
    bottom: 0;
    width: calc(100% - 16px);
  }
`;

export const AssetField = styled.div`
  font-size: 14px;
  color: #696f8c;
  white-space: nowrap;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const AssetFieldContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TipTitle = styled.h3`
  text-align: center;
  color: #fff;
  font-weight: 500;
  font-size: 18px;
  margin: unset;
`;

export const ToolTipText = styled.p`
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #fff;
  margin: unset;
  text-align: center;
  max-width: 237px;
`;

export const OuterItem = styled.div`
  & + & {
    margin-top: 12px;
  }

  &[data-isfindmatched='approx_match'] {
    margin: 0 40px;
    padding: 8px 16px 16px;
    background: #f5f7fb;
    border-radius: 8px;

    & + & {
      margin-top: 12px;
    }
  }
`;

export const RightColumn = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  grid-column: span 2;
`;

export const Label = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #8f95b2;
  margin: 16px 0 12px 0;
`;

export const ConfirmMatchActionItem = styled.button`
  padding: 6px 10px;
  width: fit-content;
  height: 100%;
  background: #1371fe;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const RejectMatchAction = styled.button`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  border: none;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  background-color: transparent;
`;
